import { cloneElement, CSSProperties, forwardRef, ReactElement } from "react";
import { theme } from "antd";
import { Hover } from "./Hover";

export const SvgButton = forwardRef<
  HTMLDivElement,
  JSX.IntrinsicElements["div"] & {
    disabled?: boolean;
    children: ReactElement;
    baseStyle?: CSSProperties;
    hoverStyle?: CSSProperties;
  }
>(function SvgButtonWithRef(
  { children: svg, disabled, baseStyle, hoverStyle, ...props },
  ref
) {
  const { token } = theme.useToken();
  return (
    <Hover
      baseStyle={{
        backgroundColor: token.colorBgContainer,
        padding: 3,
        borderRadius: 3,
        cursor: disabled ? "not-allowed" : "pointer",
        display: "inline-block",
        ...baseStyle,
      }}
      hoverStyle={{
        backgroundColor: disabled
          ? token.colorBgContainer
          : token.colorBgTextHover,
        ...hoverStyle,
      }}
    >
      <div {...props} ref={ref}>
        {cloneElement(svg, {
          ...svg.props,
          style: {
            ...svg.props.style,
            display: "block",
            color: disabled ? token.colorTextDisabled : "currentColor",
          },
        })}
      </div>
    </Hover>
  );
});
